var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1981.402px",
    height: "200px",
    viewBox: "0 0 1981.402 200",
    enableBackground: "new 0 0 1981.402 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M26.74,28.761v143.915h31.442 c16.878,0,30.249-5.553,39.997-16.691c9.787-11.104,14.642-25.408,14.642-42.754V87.978c0-17.193-4.855-31.419-14.642-42.521 C88.43,34.353,75.06,28.762,58.182,28.762H26.74V28.761z M2.002,192.259V9.177h56.181c23.968,0,43.195,7.363,57.684,22.09 c14.488,14.689,21.732,33.696,21.732,57.019v25.021c0,23.362-7.245,42.406-21.732,57.018 c-14.489,14.648-33.716,21.937-57.684,21.937H2.002V192.259z M136.828,76.295h-23.967l24.314,40.25 M26.74,172.676L2.002,9.177 L26.74,28.761L69.01,9.254l67.818,67.041l-23.736,40.25h24.083L69.01,192.259L26.74,172.676L2.002,192.259L26.74,28.761  M2.002,100.736H26.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M285.603,190.332h-95.06v-18.466h35.45V27.606 h-35.45V9.177h95.06v18.43h-35.45v144.26h35.45V190.332L285.603,190.332z M190.543,27.606l95.06-18.43l-59.61,18.43l-35.45-18.43  M285.603,9.177l-35.45,18.43l-59.61-18.43l95.06,18.43 M190.543,171.866l95.06,18.466l-59.61-18.466l-35.45,18.466  M285.603,190.332l-35.45-18.466l-59.61,18.466l95.06-18.466 M225.993,27.606l24.16,144.26 M250.153,27.606l-24.16,144.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M472.41,188.366v-95.3h-65.197v21.857h46.547 c0,31.884-12.754,56.863-46.163,56.863c-32.521,0-44.621-38.205-44.774-74.865c-0.154-35.082,13.255-66.656,40.729-67.273 c24.161-0.579,43.89,8.713,45.662,33.192h23.197l0.27-0.77c-4.585-37.667-31.058-55.361-69.128-54.283 c-45.775,1.236-63.655,44.183-63.617,89.827c0.077,45.991,19.229,94.143,67.663,94.143c28.399,0,37.994-12.412,44.66-27.642v24.25 L472.41,188.366L472.41,188.366z M452.257,164.116l-44.66,27.642l-65.543-68.582 M407.212,93.066l46.547,21.857l18.65,73.442 l-20.153-24.25l20.153-71.05l-65.197,21.857 M472.41,62.841l-66.393-55.09L340.82,80.306h22.965l-21.732,42.87h23.158 l-24.391-42.87 M406.018,7.751v21.858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M622.109,190.332h-95.061v-18.466h35.45 V27.606h-35.45V9.177h95.061v18.43H586.66v144.26h35.449V190.332L622.109,190.332z M527.049,27.606l95.061-18.43l-59.61,18.43 l-35.45-18.43 M622.109,9.177l-35.449,18.43l-59.611-18.43l95.061,18.43 M527.049,171.866l95.061,18.466l-59.61-18.466 l-35.45,18.466 M622.109,190.332l-35.449-18.466l-59.611,18.466l95.061-18.466 M562.499,27.606l24.161,144.26 M586.66,27.606 l-24.161,144.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M730.502,191.758l24.546-162.226  M730.502,29.532l24.546,162.226 M813.347,10.142l-39.11,19.391 M813.347,29.532L672.317,10.141l41.885,19.391 M755.048,29.532 h-24.546l-58.185-19.391l70.438,19.391l70.592-19.391 M672.317,29.532l141.029-19.391l-58.299,19.391 M813.347,29.532h-58.299 v162.226h-24.546V29.532h-58.185v-19.39h141.029V29.532L813.347,29.532z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M942.124,123.792l-69.205,20.856  M880.548,123.792l68.974,20.856 M922.241,8.716l28.129,135.933l41.499,47.109l-49.127-67.966 M966.591,191.758L922.241,8.716 l20.5,115.076 M901.047,8.716l-28.129,135.933l-42.616,47.109l50.246-67.966 M855.541,191.758L901.047,8.716l-20.5,115.076  M880.548,123.792h61.576L911.953,40.52h-0.771L880.548,123.792L880.548,123.792z M949.521,144.648h-76.604l-17.377,47.108h-25.239 L901.047,8.716h21.193l69.628,183.042h-25.278L949.521,144.648L949.521,144.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M1048.511,172.251h86.314v19.507h-110.975 V9.333h24.66V172.251z M1048.511,9.333l-24.66,182.425l24.66-19.507l-24.66-162.918 M1023.851,191.758l110.975-19.507  M1134.826,191.758l-86.313-19.507"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalVector);
export default __webpack_public_path__ + "static/media/digitalVector.ee7e18e9041b727df97cb30efa6ee40e.svg";
export { ForwardRef as ReactComponent };